import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import { FloatingTooltip } from '../../../../../../Floating'
import { ICON_HEIGHT_16, IconNG } from '../../../../../../Icon'
import Text from '../../../../../../Text'

import * as styles from './ApplicantProfileEmailsMaskedMessage.module.css'

import LockIcon from '../../../../../../../icons/lock.svg'

function ApplicantProfileEmailsMaskedMessage() {
  const { t } = useTranslation()

  return (
    <FloatingTooltip
      content={t('RentalPortal.ApplicantIdentityMaskedTooltipKey')}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <div className={styles.ApplicantProfileEmailsMaskedMessage}>
        <IconNG Icon={LockIcon} size={ICON_HEIGHT_16} />
        <Text isSecondary>
          {t('RentalPortal.ApplicantProfileEmailsMaskedContentKey')}
        </Text>
      </div>
    </FloatingTooltip>
  )
}

export default ApplicantProfileEmailsMaskedMessage
